"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M13 7H3c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1z"];
//# sourceMappingURL=minus.js.map